// Modo teste do ambiente cadastro-audio.oamarelinho.com.br.
//
// Ligado em tempo de build por REACT_APP_ENV=audio (.env.audio). Nesse modo os
// servicos AmarelinhoService e SurveyServices sao trocados por versoes falsas
// que nao validam nem gravam nada: cada payload que seria enviado ao backend
// fica guardado aqui, no localStorage, e e exibido em #/cadastro-audio-resultado.
//
// Nos builds de staging/production a constante vira `false` literal e o
// minificador remove o codigo dependente dela.

export const AUDIO_TEST_MODE = process.env.REACT_APP_ENV === 'audio';

export const AUDIO_TEST_RESULT_ROUTE = '#/cadastro-audio-resultado';

const CAPTURES_KEY = 'audioTestCaptures';

export interface AudioTestCapture {
  seq: number;
  at: string;
  service: string;
  method: string;
  httpMethod: 'POST' | 'PATCH';
  url: string;
  payload: unknown;
}

export class AudioTestCaptures {
  static list(): AudioTestCapture[] {
    try {
      const raw = localStorage.getItem(CAPTURES_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  }

  static record(capture: Omit<AudioTestCapture, 'seq' | 'at'>): AudioTestCapture {
    const list = AudioTestCaptures.list();
    const entry: AudioTestCapture = {
      seq: list.length + 1,
      at: new Date().toISOString(),
      ...capture
    };
    list.push(entry);
    localStorage.setItem(CAPTURES_KEY, JSON.stringify(list));
    window.dispatchEvent(new CustomEvent('audio-test-captures-changed'));
    return entry;
  }

  static clear() {
    localStorage.removeItem(CAPTURES_KEY);
    window.dispatchEvent(new CustomEvent('audio-test-captures-changed'));
  }
}

// Onde o fluxo real manda o candidato para o app de candidato, o modo teste
// manda para a pagina de resultado.
export function candidateAppUrl(path: string = ''): string {
  if (AUDIO_TEST_MODE) return AUDIO_TEST_RESULT_ROUTE;
  return process.env.REACT_APP_CANDIDATE_APP_URL! + path;
}
